import React, { useEffect, useState } from "react";
import { authFetch } from "../services/authAPI";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment/locale/fr";
import Loading from "../components/Loading";
import Pagination from "../components/Pagination";

export default function RoutePlanningPage() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [routePlanning, setRoutePlanning] = useState(null);
    const [page, setPage] = useState(1);

    const STATUS_LABELS = {
        ready: "Prêt",
        reoptimizing: "Réoptimisation",
        deleted: "Supprimé",
        uploaded: "Téléchargé",
        initial: "Initial"
    }

    const STATUS_CLASSES = {
        ready: "success",
        reoptimizing: "light",
        deleted: "danger",
        uploaded: "warning",
        initial: "info"
    }

    function formatDate(isoString, showTime = false) {
        if (!isoString) return "";
        const m = moment(isoString);
        let result = m.format("ddd DD MMM YYYY");
        if (showTime) {
            result += ` à ${m.format("HH:mm")}`;
        }
        return result;
    }

    async function fetchRoutePlanning(p) {
        setLoading(true);
        setError(null);
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/v2/routes/route-planning?page=${p}`);
            if (!response.ok) {
                const err = await response.json().catch(() => null);
                setError(err?.error || "Aucune route disponible");
                return;
            }
            const data = await response.json();
            setRoutePlanning(data);
        } catch (err) {
            setError("Erreur lors du chargement du ticket.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchRoutePlanning(page);
    }, [page]);

    return (
        <>
            <div className="card mb-4">
                <div className="card-header py-3">
                <div className="row py-3">
                    <div className="col-sm-6 text-center text-sm-start">
                        <h5 className="mb-4 mb-sm-0 mt-2">
                            Planification des routes
                        </h5>
                    </div>
                </div>
            </div>
                <div className="card-body">
                    {loading ? (
                        <>
                            <Loading />
                        </>
                    ) : error ? (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    ) : !routePlanning?.data?.length ? (
                        <p>Aucune route disponible</p>
                    ) : (
                    <>
                    <table className="table table-hover card-body align-middle mb-0 bg-white" id="tableRoutePlanning">
                        <thead className="bg-light">
                            <tr>
                                <th>Site</th>
                                <th>Statut</th>
                                <th>Visite</th>
                                <th>Publié le</th>
                                <th>Dernière mise à jour</th>
                                <th>Planifié pour le</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {routePlanning.data.map((route) => (
                                <tr key={route.id} onClick={() => navigate(`/routes/planning/${route.id}`)} style={{ cursor: "pointer" }}>
                                    <td>{route.sorting_center.code}</td>
                                    <td>
                                        <span className={"badge badge-" + STATUS_CLASSES[route.status]}>{STATUS_LABELS[route.status]}</span>
                                    </td>
                                    <td>{route.point_visits_count}</td>
                                    <td>{formatDate(route.created_at, true)}</td>
                                    <td>{formatDate(route.last_sync_at, true)}</td>
                                    <td>{formatDate(route.scheduled_for)}</td>
                                    <td>...</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Pagination page={page} totalPages={routePlanning.pages} onPageChange={setPage} />
                    </>
                    )}
                </div>
            </div>
        </>
    );
}